import React from 'react';
import { useNavigate } from 'react-router-dom';
import { SquareBtn, WrapperComponent } from '../../../_imports';
import './resume_cta.css';

function ResumeCTA() {
    const navigate = useNavigate();

    return (
        <section className="resume-cta-section">
            <WrapperComponent>
                <div className="resume-cta-card">
                    <div className="resume-cta-content">
                        <h2 className="resume-cta-title">Ainda não tem um currículo?</h2>
                        <p className="resume-cta-description">
                            Clique no botão ao lado e crie um totalmente gratuito, reserve um tempinho e preencha os dados do seu currículo e nós criamos ele no formato correto.
                        </p>
                    </div>
                    <div className="resume-cta-action">
                        <SquareBtn
                            text="Criar currículo"
                            onClick={() => navigate('/criarcurriculo')}
                            className="green-square-btn"
                        />
                    </div>
                </div>
            </WrapperComponent>
        </section>
    );
}

export default ResumeCTA;
